<div class="loggedOutHome">
    <div class="wrapper">
        <div class="header"><p>Welcome to the McLane Connect Portal</p></div>
        <div class="testApplications">

            <div class="appHolder">
                <div class="applicationDivHolder">
                    <img class="logo" src="assets/theme/mclane/img/fs-sourcelink.png"/>
                    <div class="name"><p class="text">SourceLink</p></div>
                </div>
                <div class="applicationText"><p>Place a order on our Multiplatform SourceLink Application</p></div>
            </div>
            <div class="appHolder">
                <div class="applicationDivHolder">
                    <img class="logo" src="assets/theme/mclane/img/mclane-color.png"/>
                    <div class="name"><p class="text">Online Invoicing</p></div>
                </div>
                <div class="applicationText"><p>Access your company invoices </p></div>
            </div>


        </div>
        <div class="loginButton log" (click)="login()"><p>Login</p></div>
    </div>


</div>
